import { Injectable } from '@angular/core';
import { PackagePlan } from '../../model/PackagePlan';
import { BackendService } from './backend.service';
import { PRIVATE_PRICE_PLANS, PUBLIC_PRICE_PLANS } from './gql_queries/price-plan.graphql';
import { UserService } from './user.service';

type PublicPackagePlans = {
  publicPricePlans: {
    active: PackagePlan[]
  }
};
type PackagePlans = {
  pricePlans: {
    active: PackagePlan[]
  }
};

@Injectable({
  providedIn: 'root'
})
export class PackagePlanServiceService {


  constructor(
    private readonly backendService: BackendService,
    private readonly userService: UserService
  ) {
  }

  async getPackagePlans(): Promise<PackagePlan[]> {

    const annonymous = !this.userService.isUserLoggedIn();
    if (annonymous) {
      const query = PUBLIC_PRICE_PLANS;
      const result = await this.backendService.executeGraphQL(query, {});
      console.log('getPackagePlans.result: ', result.data);
      const res = result.data as unknown as PublicPackagePlans;
      return res.publicPricePlans.active;
    } else {
      const query = PRIVATE_PRICE_PLANS;
      const result = await this.backendService.executeGraphQL(query, {ppType: 'prepaid'});
      console.log('getPackagePlans.result: ', result.data);
      const res = result.data as unknown as PackagePlans;
      return res.pricePlans.active;
    }
  }
}
